import React from 'react';

import {useSelector} from "react-redux";

import {
    setPlanType,
    setAmount,
    setFirst_payment_amount,
    setBilling_interval,
    setStart_date,
    setOrder_id,
} from "../../../../Features/Auth/authSlice";

import {incrementLoginStep, decrementLoginStep} from "../../../../Features/Misc/loginSlice";
import { Animate } from "react-simple-animate";

import ProgressBar from "../../../Components/ProgressBar";
import { useDispatch } from "react-redux";


export default function ChooseSubscription(props) {

    const dispatch = useDispatch()

    const {
        planType,
        userType
    } = useSelector((state) => state.auth)


    const focusedStyle = "bg-purple-focused border-light-pink rounded-lg border-2 h-auto px-4 py-1 flex flex-row justify-between items-center"
    const unfocusedStyle = "bg-purple-dashboard border-light-border rounded-lg border-2 h-auto px-4 py-1 flex flex-row justify-between items-center"

    const handleClick = (val) =>{
        dispatch(setPlanType(val))
        dispatch(setStart_date(new Date().toISOString().slice(0,10)))
        dispatch(setOrder_id())
        if(val === 1){
            dispatch(setAmount(15))
            dispatch(setBilling_interval(1))
            dispatch(setFirst_payment_amount(15))

        } else if(val === 2){
            dispatch(setAmount(10))
            dispatch(setBilling_interval(3))
            dispatch(setFirst_payment_amount(30))
        } else if(val === 3){
            dispatch(setAmount(5))
            dispatch(setBilling_interval(12))
            dispatch(setFirst_payment_amount(60))
        }
    }

    const handleConfirm = () =>{
        dispatch(incrementLoginStep())
    }

    const handleCancel = () =>{
        dispatch(decrementLoginStep())
    }

    return (

        <div className="mx-4 col-start-1 col-end-13 row-start-3 row-end-13 flex text-xl text-white flex-col gap-4">
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem" }} duration={0.7} >

            <div className={`text-2xl`}><p>Sign Up</p></div>
            <div className="text-2xl"><p>Choose Subscription Plan</p></div>
            <div className="text-base"><p>Simple and flexible pricing.</p></div>

            <div className="flex flex-col gap-4 my-6">

                <div className={planType === 1 ? focusedStyle : unfocusedStyle} onClick={() => handleClick(1)}>
                    <div className="">
                        <div>1 Month</div>
                        <div className={"text-sm "}>01 Plan</div>
                    </div>

                    <div className={`w-32 pl-4`}>£15/month</div>

                    <div className="flex flex-col items-end w-28 ">
                        <i className={`text-2xl + ${planType === 1 ? " ri-checkbox-circle-fill " : "ri-checkbox-blank-circle-line text-light-border"}`}></i>
                        <div className="h-3"></div>
                    </div>
                </div>


                <div className={planType === 2 ? focusedStyle : unfocusedStyle} onClick={() => handleClick(2)}>
                    <div className="">
                        <div>3 Months</div>
                        <div className={"text-sm "}>02 Plan</div>
                    </div>

                    <div className={`w-32 px-2 pl-4`}>£10/month</div>

                    <div className="flex flex-col items-end w-28 ">
                        <i className={`text-2xl + ${planType === 2 ? " ri-checkbox-circle-fill " : "ri-checkbox-blank-circle-line text-light-border"}`}></i>
                        <div className={planType === 2 ? "text-xs" : "text-xs text-light-border"}>Payable in one sum</div>
                    </div>
                </div>


                <div className={planType === 3 ? focusedStyle : unfocusedStyle} onClick={() => handleClick(3)}>
                    <div className="">
                        <div>12 Months</div>
                        <div className={"text-sm "}>03 Plan</div>
                    </div>

                    <div className={`w-32 px-2 pl-4`}>£5/month</div>

                    <div className="flex flex-col items-end w-28 ">
                        <i className={`text-2xl + ${planType === 3 ? " ri-checkbox-circle-fill " : "ri-checkbox-blank-circle-line text-light-border"}`}></i>
                        <div className={planType === 3 ? "text-xs" : "text-xs text-light-border"}>Payable yearly</div>
                    </div>

                </div>
            </div>



            <div className="flex flex-row gap-4 w-full ">
                <button onClick={() => handleCancel()} className={`border-gold-accent/75 rounded-lg border-2 px-4 py-2 h-14 grow cursor-pointer`  }>Cancel</button>
                <button onClick={() => handleConfirm()} className="bg-gold-accent hover:bg-gold-accent-hover h-14 px-4 py-2 rounded-lg grow cursor-pointer">Confirm</button>
            </div>

            <ProgressBar width={"w-14"} attachLoginQuery={true}/>

            </Animate>

        </div>

    );
}
